import {
  CopyOutlined,
  DeleteOutlined,
  EyeOutlined,
  UndoOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import {
  Button,
  Divider,
  Flex,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  Upload,
} from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  deleteBanner,
  getBannerCategoryList,
  getBannerDetail,
  getBannerDetailButtonActionNameList,
  updateBanner,
} from '../../api/banner.api'
import { salusS3 } from '../../api/s3.api'
import ContentHeader from '../../components/shared/ContentHeader'
import '../../styles/banner.scss'
import {
  BANNER_CLICK_TYPE,
  BANNER_DETAIL_PAGE_JSON_EXAMPLE,
  BANNER_EXTERNAL_ROUTE_JSON_EXAMPLE,
  BANNER_INTERNAL_ROUTE_JSON_EXAMPLE,
} from '../../utils/banner'

const BannerUpdatePage = () => {
  const { bannerId } = useParams()
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [banner, setBanner] = useState(null)
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewVisibleDetailPageImage, setPreviewVisibleDetailPageImage] =
    useState(false)
  const [textContent, setTextContent] = useState(banner?.bannerImageUrl)
  const [localImage, setLocalImage] = useState(null) // 배너 이미지
  const [localImageFileObj, setLocalImageFileObj] = useState(null) // 배너 이미지
  const [localDetailPageImage, setLocalDetailPageImage] = useState(null) // 상세페이지 내부 이미지
  const [localDetailPageImageFileObj, setLocalDetailPageImageFileObj] =
    useState(null) // 상세페이지 내부 이미지
  const [showUpload, setShowUpload] = useState(false)
  const [uploadKey, setUploadKey] = useState(Date.now())
  const [uploadKeyDetailPageImage, setUploadKeyDetailPageImage] = useState(
    Date.now(),
  )
  const [newGeneratedDetailPageImageUrl, setNewGeneratedDetailPageImageUrl] =
    useState(null)
  const [navType, setNavType] = useState(banner?.navigationType || '')
  const [bannerCategoryList, setBannerCategoryList] = useState([])
  const [detailButtonActionNameList, setDetailButtonActionNameList] = useState(
    [],
  )
  const [detailPageActionType, setDetailPageActionType] = useState(
    banner?.detailPageActionType ?? null,
  )
  const [detailPageActionName, setDetailPageActionName] = useState(
    banner?.detailPageActionName ?? undefined,
  )
  const [isShow, setIsShow] = useState(banner?.isShow ?? true)
  const [contentType, setContentType] = useState('image') // 'image' or 'text'

  const isImageUrl = (url) =>
    typeof url === 'string' && url.match(/\.(jpg|jpeg|png|gif|webp|svg)$/i)

  useEffect(() => {
    fetchBannerCategoryList() // 배너 포지션  카테고리 모록
    fetchBannerDetailButtonActionNameList() //디테일 액션 타입 목록
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    fetchBanner()
    // eslint-disable-next-line
  }, [bannerId])

  useEffect(() => {
    if (banner && banner.navigationType) {
      setNavType(banner.navigationType)
    }
    if (banner && banner.detailPageActionType !== undefined) {
      setDetailPageActionType(banner.detailPageActionType)
    }
    if (banner && banner.detailPageActionName !== undefined) {
      setDetailPageActionName(banner.detailPageActionName)
    }
    if (banner && banner.isShow !== undefined) {
      setIsShow(banner.isShow)
    }
    if (banner && banner.bannerImageUrl !== undefined) {
      setContentType(isImageUrl(banner.bannerImageUrl) ? 'image' : 'text')
      setTextContent(banner.bannerImageUrl)
    }
  }, [banner])

  const fetchBannerCategoryList = async () => {
    const res = await getBannerCategoryList()
    setBannerCategoryList(Array.isArray(res.data) ? res.data : [])
  }
  const fetchBannerDetailButtonActionNameList = async () => {
    const res = await getBannerDetailButtonActionNameList()
    setDetailButtonActionNameList(Array.isArray(res.data) ? res.data : [])
  }
  const fetchBanner = async () => {
    setLoading(true)
    try {
      const res = await getBannerDetail(bannerId)
      setBanner(res.data)
      form.setFieldsValue(res.data)
      setShowUpload(false)
      setLocalImage(null)
    } catch (e) {
      Modal.error({ title: '조회 실패', content: e.message })
    } finally {
      setLoading(false)
    }
  }

  const saveAlert = () => {
    Swal.fire({
      text: '저장하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '저장',
      cancelButtonText: '취소',
    }).then((result) => {
      if (result.isConfirmed) {
        handleSave()
      }
    })
  }

  const handleSave = async () => {
    setLoading(true)
    const values = form.getFieldsValue()
    let newBannerS3Url = null
    if (contentType === 'text') {
      newBannerS3Url = textContent
    } else {
      if (localImageFileObj) {
        newBannerS3Url = await s3Upload(localImageFileObj)
      } else {
        newBannerS3Url = values.bannerImageUrl
      }
    }
    console.log('newBannerS3Url', newBannerS3Url)
    try {
      const params = {
        id: Number(bannerId),
        isShow,
        position: values.position,
        sortOrder: Number(values.sortOrder),
        bannerImageUrl: newBannerS3Url,
        imageUrl: newBannerS3Url,
        navigationType: values.navigationType,
        navigationPayload: values.navigationPayload,
        detailPageActionType: detailPageActionType,
        detailPageActionName: detailPageActionName,
        detailPageActionPayload: values.detailPageActionPayload,
        targetId: values.targetId,
        buttonText: values.buttonText,
      }
      await updateBanner(params)
      Modal.success({ title: '수정 완료', onOk: () => navigate(-1) })
    } catch (error) {
      Modal.error({ title: '수정 실패', content: error.message })
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteConfirm = () => {
    Swal.fire({
      text: '삭제하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete()
      }
    })
  }

  const handleDelete = async () => {
    try {
      await deleteBanner(bannerId)
      Modal.success({ title: '삭제 완료', onOk: () => navigate(-1) })
    } catch (error) {
      Modal.error({ title: '삭제 실패', content: '다시 시도해주세요' })
    }
  }

  // 이미지 변경 버튼 클릭 시 업로드 모드로 전환
  const handleChangeImage = () => {
    setShowUpload(true)
    setLocalImage(null)
    setLocalImageFileObj(null)
    // form.setFieldsValue({ bannerImageUrl: '' })
  }
  const handleChangeImageToOriginal = () => {
    setShowUpload(false)
    setLocalImage(null)
    setLocalImageFileObj(null)
  }

  // 3. S3 업로드
  const s3Upload = async (file, idx) => {
    console.log('s3Upload file = ', file)
    let s3Path = `images/banner/${bannerId}/${file.name}`

    let params = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: s3Path,
      Body: file,
    }
    let res = await salusS3.putObject(params).promise()
    // console.log('s3Upload res = ', res)
    if (res.success === true) {
      return `https://sugarcoach-assets.s3.ap-northeast-2.amazonaws.com/${s3Path}`
    }
    return null
  }

  // antd Upload change 핸들러
  const handleUploadChange = (info) => {
    // 초기화
    setLocalImage(null)
    setLocalImageFileObj(null)

    let file =
      info.file.originFileObj ||
      (info.fileList && info.fileList[0] && info.fileList[0].originFileObj)
    if (file) {
      setLocalImageFileObj(file)
      const reader = new FileReader()
      reader.onload = (ev) => {
        setLocalImage(ev.target.result)
      }
      reader.readAsDataURL(file)
      setUploadKey(Date.now())
    }
  }

  const handleUploadChangeDetailPageImage = (info) => {
    setLocalDetailPageImage(null)
    setLocalDetailPageImageFileObj(null)
    setNewGeneratedDetailPageImageUrl(null)

    let file =
      info.file.originFileObj ||
      (info.fileList && info.fileList[0] && info.fileList[0].originFileObj)
    if (file) {
      setLocalDetailPageImageFileObj(file)
      const reader = new FileReader()
      reader.onload = (ev) => {
        console.log('ev.target.result', ev.target.result)
        setLocalDetailPageImage(ev.target.result)
      }
      reader.readAsDataURL(file)
      setUploadKeyDetailPageImage(Date.now())
    }
  }

  /* payload 예시 복사 */
  const getJsonExample = (type) => {
    switch (type) {
      case 'EXTERNAL_LINK':
        return BANNER_EXTERNAL_ROUTE_JSON_EXAMPLE
      case 'INTERNAL_ROUTE':
        return BANNER_INTERNAL_ROUTE_JSON_EXAMPLE
      case 'DETAIL_PAGE':
        return BANNER_DETAIL_PAGE_JSON_EXAMPLE
      default:
        return ''
    }
  }

  const copyJsonExample = () => {
    const example = getJsonExample(navType)
    if (example) {
      navigator.clipboard.writeText(example)
      Modal.success({ title: 'JSON 예시 복사 완료' })
    } else {
      Modal.info({ title: '예시 없음', content: '이동타입을 먼저 선택하세요.' })
    }
  }
  const copyDetailPageActionPayloadExample = () => {
    navigator.clipboard.writeText(BANNER_INTERNAL_ROUTE_JSON_EXAMPLE)
    Modal.success({ title: 'JSON 예시 복사 완료' })
  }

  if (loading && !banner) {
    return <Spin style={{ display: 'block', margin: '100px auto' }} />
  }
  if (!banner) {
    return null
  }

  return (
    <div className="banner-update-container">
      <ContentHeader title="배너 수정" />

      <Form
        form={form}
        layout="vertical"
        initialValues={banner}
        style={{
          maxWidth: 650,
          margin: '60px auto',
          padding: '0 20px',
          gap: 18,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Link
          style={{
            marginBottom: 12,
            display: 'block',
            textDecoration: 'underline',
            fontSize: 16,
            fontWeight: 600,
          }}
          target="_blank"
          to="https://www.notion.so/23e203bac0ea801ca0acef7f11d4c194?source=copy_link"
        >
          📋 작성 가이드 보기
        </Link>
        <Flex justify="space-between">
          <h2> 필수 정보</h2>
          <Button
            icon={<DeleteOutlined />}
            danger
            onClick={handleDeleteConfirm}
          >
            삭제
          </Button>
        </Flex>
        {/*노출여부*/}
        <Row
          className={`${'product-register-border-box'}`}
          style={{ marginTop: 20, marginBottom: 18, alignItems: 'center' }}
        >
          <Form.Item
            label="노출 여부"
            name="isShow"
            rules={[{ required: true }]}
          >
            <Radio.Group
              name="isShow"
              value={isShow}
              onChange={(e) => setIsShow(e.target.value)}
              optionType="button"
              buttonStyle="solid"
            >
              <Radio.Button value={true}>노출</Radio.Button>
              <Radio.Button value={false}>미노출</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Form.Item
          label="노출위치"
          name="position"
          rules={[{ required: true }]}
        >
          <Select
            options={bannerCategoryList.map((cat) => ({
              value: cat.key,
              label: cat.label,
            }))}
          />
        </Form.Item>
        <Form.Item
          label="정렬순서"
          name="sortOrder"
          rules={[{ required: true }]}
          min={1}
        >
          <Input type="number" />
        </Form.Item>
        <Form.Item
          label="배너 이미지/콘텐츠"
          name="bannerImageUrl"
          rules={[{ required: !localImage && !showUpload }]}
        >
          <Radio.Group
            value={contentType}
            onChange={(e) => setContentType(e.target.value)}
            style={{ marginBottom: 8 }}
          >
            <Radio.Button value="image">이미지로 관리</Radio.Button>
            <Radio.Button value="text" onClick={handleChangeImageToOriginal}>
              텍스트로 관리
            </Radio.Button>
          </Radio.Group>
          {contentType === 'image' ? (
            !showUpload ? (
              <>
                <div style={{ margin: '8px 0 16px 0' }}>
                  <div
                    style={{ display: 'inline-block', position: 'relative' }}
                  >
                    <img
                      src={form.getFieldValue('bannerImageUrl')}
                      alt="banner preview"
                      className="banner-preview-img"
                      onClick={() => setPreviewVisible(true)}
                    />
                    <span className="banner-preview-eye">
                      <EyeOutlined />
                    </span>
                  </div>
                </div>
                <Button onClick={handleChangeImage}>이미지 선택</Button>
              </>
            ) : (
              <>
                {(localImage || form.getFieldValue('bannerImageUrl')) && (
                  <div className="banner-preview-img-wrap">
                    <img
                      src={localImage || form.getFieldValue('bannerImageUrl')}
                      alt="local preview"
                      className="banner-preview-img"
                      onClick={() => setPreviewVisible(true)}
                    />
                    <span className="banner-preview-eye">
                      <EyeOutlined />
                    </span>
                  </div>
                )}
                <Flex gap={6}>
                  <Upload
                    key={uploadKey}
                    accept="image/*"
                    showUploadList={false}
                    beforeUpload={() => false}
                    onChange={handleUploadChange}
                    fileList={[]}
                    style={{ marginBottom: 8 }}
                  >
                    <Button icon={<UploadOutlined />}>이미지 업로드</Button>
                  </Upload>
                  <Button
                    icon={<UndoOutlined />}
                    onClick={handleChangeImageToOriginal}
                  >
                    초기화
                  </Button>
                </Flex>
              </>
            )
          ) : (
            <Input
              value={textContent}
              placeholder="텍스트 콘텐츠 입력"
              onChange={(e) => setTextContent(e.target.value)}
            />
          )}
        </Form.Item>
        <Form.Item
          label="이동타입"
          name="navigationType"
          rules={[{ required: true }]}
        >
          <Input.Group compact>
            <Select
              style={{ width: 200 }}
              options={Object.entries(BANNER_CLICK_TYPE).map(
                ([value, label]) => ({ value, label }),
              )}
              value={navType}
              onChange={(v) => {
                setNavType(v)
                form.setFieldValue('navigationType', v)
                console.log('v', v)
              }}
            />
            <Button
              icon={<CopyOutlined />}
              onClick={copyJsonExample}
              // disabled={!getJsonExample(navType)}
            >
              예시 복사
            </Button>
          </Input.Group>
        </Form.Item>
        <Form.Item
          label="이동정보 (JSON)"
          name="navigationPayload"
          rules={[{ required: true }]}
        >
          <Input.TextArea rows={10} />
        </Form.Item>
        {navType === 'DETAIL_PAGE' && (
          <>
            <Divider />
            <h2 style={{ marginBottom: 20 }}>상세페이지 정의</h2>

            <Form.Item label="상세 페이지 이미지 주소 생성(전체 이미지)">
              <Upload
                key={uploadKeyDetailPageImage}
                accept="image/*"
                showUploadList={false}
                beforeUpload={() => false}
                onChange={handleUploadChangeDetailPageImage}
                fileList={[]}
              >
                <Button icon={<UploadOutlined />}>
                  {localDetailPageImage ? '이미지 변경' : '이미지 업로드'}
                </Button>
              </Upload>

              {localDetailPageImage && (
                <>
                  <div className="banner-preview-img-wrap">
                    <img
                      src={localDetailPageImage}
                      alt="local preview"
                      className="banner-preview-img"
                      onClick={() => setPreviewVisibleDetailPageImage(true)}
                    />
                    <span className="banner-preview-eye">
                      <EyeOutlined />
                    </span>
                  </div>
                  {newGeneratedDetailPageImageUrl && (
                    <p>
                      {newGeneratedDetailPageImageUrl}
                      <Button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            newGeneratedDetailPageImageUrl,
                          )
                          Modal.success({ title: '이미지 주소 복사 완료' })
                        }}
                      >
                        복사
                      </Button>
                    </p>
                  )}
                  {!newGeneratedDetailPageImageUrl && (
                    <Button
                      onClick={async () => {
                        const imageUrl = await s3Upload(
                          localDetailPageImageFileObj,
                        )
                        setNewGeneratedDetailPageImageUrl(imageUrl)
                      }}
                    >
                      이미지 주소 생성하기
                    </Button>
                  )}
                </>
              )}
            </Form.Item>
            <Form.Item label="버튼 사용 여부">
              <Radio.Group
                value={detailPageActionType}
                onChange={(e) => {
                  setDetailPageActionType(e.target.value)
                  form.setFieldValue('detailPageActionType', e.target.value)
                }}
              >
                <Radio value="BUTTON">버튼 사용</Radio>
                <Radio value={null}>버튼 없음</Radio>
              </Radio.Group>
            </Form.Item>
            {detailPageActionType === 'BUTTON' && (
              <>
                <Form.Item
                  label="버튼 클릭 액션 유형"
                  name="detailPageActionName"
                  rules={[{ required: true }]}
                >
                  <Select
                    value={detailPageActionName}
                    onChange={(v) => {
                      setDetailPageActionName(v)
                      form.setFieldValue('detailPageActionName', v)
                    }}
                    options={detailButtonActionNameList.map((item) => ({
                      value: item.key,
                      label: item.label,
                    }))}
                    allowClear
                  />
                </Form.Item>
                <Form.Item
                  label="버튼 텍스트"
                  name="buttonText"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                {/* 상세 페이지 유형에따라 보이는 화면 다름 */}
                {detailPageActionName !== 'NAVIGATION' && (
                  <Form.Item
                    rules={[{ required: true }]}
                    label={
                      detailPageActionName === 'LINK'
                        ? '외부 링크 주소'
                        : '발급 쿠폰 코드'
                    }
                    name="targetId"
                  >
                    <Input />
                  </Form.Item>
                )}

                {detailPageActionName === 'NAVIGATION' && (
                  <>
                    <Form.Item
                      label="상세 페이지 이동 정보(JSON)"
                      name="detailPageActionPayload"
                      rules={[{ required: true }]}
                    >
                      <Input.TextArea rows={10} />
                    </Form.Item>
                    <Button
                      icon={<CopyOutlined />}
                      onClick={copyDetailPageActionPayloadExample}
                      // disabled={!getJsonExample(navType)}
                    >
                      예시 복사
                    </Button>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Form>
      <div className="banner-update-fixed-footer">
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={saveAlert}
          disabled={loading}
        >
          저장
        </Button>
        <Button style={{ marginLeft: 8 }} onClick={() => navigate(-1)}>
          취소
        </Button>
      </div>
      <Modal
        width={window.innerWidth * 0.6}
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
      >
        <img
          src={localImage || form.getFieldValue('bannerImageUrl')}
          alt="banner"
          style={{ width: '100%' }}
        />
      </Modal>
      <Modal
        width={window.innerWidth * 0.6}
        open={previewVisibleDetailPageImage}
        footer={null}
        onCancel={() => setPreviewVisibleDetailPageImage(false)}
        centered
      >
        <img
          src={localDetailPageImage}
          alt="banner"
          style={{ width: '100%' }}
        />
      </Modal>
    </div>
  )
}

export default BannerUpdatePage
